export default __webpack_public_path__ + "static/portal/img/main.e884c95.gif";